

import { library } from '@fortawesome/fontawesome-svg-core'
import { faWindowClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faWindowClose)
import * as React from 'react';
import './style.css';

interface IPopupProps {
  header?: string;
  content?: Element | JSX.Element | string;
  visible: boolean;
  width?: string | number;
  height?: string | number;
  close?: () => void;
}

const stopClick = (event: React.MouseEvent<any>) => event.stopPropagation();

class Popup extends React.Component<IPopupProps> {
  constructor(props: any, context: any) {
    super(props, context);
  }
  public render() {
    return (
      <div className={`Popup ${this.props.visible ? '' : 'hidden'}`} onClick={this.props.close}>
        <div className="content" onClick={stopClick} style={{ width: this.props.width, height: this.props.height }}>
          {this.props.close && <button className="close" onClick={this.props.close}><FontAwesomeIcon icon="window-close"/></button>}
          {this.props.header && <h3>{this.props.header}</h3>}
          <div className="children">{this.props.content || this.props.children}</div>
        </div>
      </div >
    );
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/Popup/index.tsx